import { Component, Event, EventEmitter, h, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'biel-search-ask-ai-button',
  styleUrl: 'biel-search-ask-ai-button.css',
  shadow: true,
})
export class BielSearchAskAiButton {
  @Prop() resultTitle: string;
  @Prop() resultFragment: string;
  @Prop() isSelected: boolean;

  @Event() askAiClicked: EventEmitter<void>;

  @Listen('keydown', { target: 'window' })
  handleKeyDown(event: KeyboardEvent) {
    if (this.isSelected && event.key === 'Enter') {
      event.preventDefault();
      this.handleAskAiClick();
    }
  }

  handleAskAiClick() {
    this.askAiClicked.emit();
  }

  render() {
    return (
      <a class="biel-search-ask-ai" tabIndex={this.isSelected ? 0 : -1} onClick={() => this.handleAskAiClick()}>
        <div class={`biel-search-ask-ai-container ${this.isSelected ? "selected" : ""}`}>
          <div class="biel-search-ask-ai-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bot"><path d="M12 8V4H8" /><rect width="16" height="12" x="4" y="8" rx="2" /><path d="M2 14h2" /><path d="M20 14h2" /><path d="M15 13v2" /><path d="M9 13v2" /></svg>
          </div>
          <div class="biel-search-ask-ai-text-container">
            <span class="biel-search-ask-ai__title">{this.resultTitle}</span>
            <span class="biel-search-ask-ai__description">{this.resultFragment}</span>
          </div>
        </div>
      </a>
    );
  }
}
